import { AppBar, Box, Toolbar } from '@mui/material';
import { LogoHeaderCba } from '../../assets/icons/Icons';
import { selectCurrentUser } from '../../redux/slices/authSlice';
import { Tab } from '@mui/material';
import { Tabs } from '@mui/material';
import { useAppSelector } from '../../hooks/reduxHooks';
import { useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useMemo, useState } from 'react';
import UserCardHeader from '../UserCardHeader/UserCardHeader';

const appBarStyles = {
    '& .MuiAppBar-root': {
        background: 'var(--primary)',
        maxHeight: '60px',
        position: 'static'
    },
    '& .MuiToolbar-root': {
        display: 'flex',
        justifyContent: 'space-between',
        padding: { xs: '0 5px !important', sm: '0 24px !important', md: '0 48px !important' }
    },
    '& .MuiTypography-root': {
        fontSize: { xs: '14px', sm: '20px' },
        textWrap: 'balance',
        textAlign: 'center',
        fontWeight: 600
    }
};

const PATHS: any = ['consulta-documentos', 'carga-documentos', 'administracion'];

function Header() {
    const { pathname } = useLocation();
    const user = useAppSelector(selectCurrentUser);
    const navigate = useNavigate();
    const pathIndex = useMemo(() => PATHS.findIndex((p: any) => pathname?.includes(p)), [pathname]);
    const [value, setValue] = useState(pathIndex < 0 ? 0 : pathIndex);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        navigate(`/app/${PATHS[newValue]}`, { replace: true });
        setValue(newValue);
    };

    useEffect(() => {
        if (!PATHS?.find((p: any) => pathname?.includes(p))) {
            navigate('/app/consulta-documentos', { replace: true });
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (value !== pathIndex) setValue(pathIndex);
        // eslint-disable-next-line
    }, [pathname, value]);

    return (
        <Box sx={{ ...appBarStyles }}>
            <AppBar>
                <Toolbar>
                    <LogoHeaderCba />
                    <Tabs
                        className="header-tabs"
                        onChange={handleChange}
                        value={value > 0 ? value : 0}
                    >
                        <Tab label="Consultar" />
                        <Tab label="Adjuntar" />
                        {user?.esAdmin && <Tab label="Administración" />}
                    </Tabs>
                    <UserCardHeader />
                </Toolbar>
            </AppBar>
        </Box>
    );
}

export default Header;
